import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const CreateFaqSectionService = (title: string) => {
  return HTTP_CLIENT.post(`${Endpoint.faqs.addFaqSection}`, { title });
};
const CreateQuestionService = (
  sectionId: number,
  title: string,
  detail: string
) => {
  return HTTP_CLIENT.post(`${Endpoint.faqs.addFaqQuestion}/${sectionId}`, {
    title,
    detail,
  });
};

const DeleteFaqSectionService = (sectionId: number) => {
  return HTTP_CLIENT.delete(`${Endpoint.faqs.deleteFaqSection}/${sectionId}`);
};

const DeleteFaqQuestionService = (questionId: number) => {
  return HTTP_CLIENT.delete(`${Endpoint.faqs.deleteFaqQuestion}/${questionId}`);
};

const GetAllSectionsService = (page = 1, limit = 10) => {
  return HTTP_CLIENT.get(
    `${Endpoint.faqs.getAllSections}?&page=${page}&limit=${limit}`
  );
};
const GetSectionQuestionService = (sectionId: number) => {
  return HTTP_CLIENT.get(`${Endpoint.faqs.getSectionQuestions}/${sectionId}`);
};
const UpdateSectionService = (sectionId: number, title: string) => {
  return HTTP_CLIENT.patch(`${Endpoint.faqs.updateFaqSection}/${sectionId}`, {
    title,
  });
};
const UpdateQuestionService = (
  questionId: number,
  title: string,
  detail: string
) => {
  return HTTP_CLIENT.patch(`${Endpoint.faqs.updateFaqQuestion}/${questionId}`, {
    title,
    detail,
  });
};

export {
  CreateFaqSectionService,
  CreateQuestionService,
  DeleteFaqSectionService,
  DeleteFaqQuestionService,
  GetAllSectionsService,
  GetSectionQuestionService,
  UpdateSectionService,
  UpdateQuestionService,
};
